import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  selectRoot: {
    paddingRight: '6px',
    maxHeight: '38px',
    '&:focus': {
      backgroundColor: 'unset',
    },
    '& > div:first-of-type': {
      fontWeight: 500,
    },
  },
  disabledSelect: {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderColor: 'rgba(0, 0, 0, 0.12)',
    cursor: 'default',
    '& .MuiSelect-icon': {
      display: 'none',
    },
    '&:hover': 'none',
  },
  lockIcon: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '& > svg': {
      color: theme.palette.primary.sideBarIconColor,
      opacity: 0.8,
      padding: '5px',
      width: '0.7em',
      height: '0.7em',
      '&:hover': {
        backgroundColor: '#3d3d3d0c',
        borderRadius: '50%',
      },
    },
  },
  box: {
    minWidth: '120px',
    marginRight: '16px',
    fontSize: '14px',
  },
  label: {
    fontWeight: 500,
    fontSize: '14px',
    color: theme.palette.primary.sideBarTextColor,
    opacity: 0.5,
    '&.Mui-focused': {
      color: theme.palette.primary.sideBarTextColor,
      opacity: 0.5,
    },
  },
  colorizeSelected: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '& > svg': {
      color: theme.palette.primary.contrastText,
    },
    '& div': {
      color: theme.palette.primary.contrastText,
    },
  },
  selectElement: {
    fontWeight: 500,
    fontSize: '14px',
  },
  menuItem: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    fontWeight: 400,
    fontSize: '14px',
  },
  menuPaper: {
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.25)',
    fontWeight: 500,
    fontSize: '14px',
  },
  tooltip: {
    backgroundColor: 'white',
    color: 'black',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
  noAccess: {
    fontSize: '14px',
    color: theme.palette.primary.sideBarIconColor,
    textAlign: 'center',
    padding: '8px',
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
};
